<template>
  <!--<div style="position: absolute">-->
  <div id="slide-list-segment" :style="getColorBtn">
    <b-row class="mb-4 card-nav">
      <b-col cols="11" ms="11" class="col-11-search">
        <div class="search-col">
          <b-input-group class="search-group">
            <b-input-group-append class=" search-icon" v-on:click="searchTitle()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1.5em"
                height="1.5em"
                viewBox="0 0 40 40"
              >
                <path
                  id="Color"
                  d="M28.879,28.929a1.083,1.083,0,0,1-.76-.305l-6.96-6.712v-.072A13.25,13.25,0,0,1,7.772,23.775,12.758,12.758,0,0,1,3.4,20.785,12.074,12.074,0,0,1,3.763,3.629a13.2,13.2,0,0,1,17.791-.352A12.079,12.079,0,0,1,22.648,20.4h.075l6.96,6.712a1.007,1.007,0,0,1-.043,1.507A1.1,1.1,0,0,1,28.879,28.929ZM12.857,2.143A10.468,10.468,0,0,0,2.143,12.321a9.863,9.863,0,0,0,3.138,7.2A10.935,10.935,0,0,0,12.857,22.5a11.15,11.15,0,0,0,4.1-.775,10.724,10.724,0,0,0,3.476-2.206,10.11,10.11,0,0,0,2.322-3.3,9.7,9.7,0,0,0,.815-3.9,9.862,9.862,0,0,0-3.138-7.2A10.934,10.934,0,0,0,12.857,2.143Z"
                  transform="translate(5 6)"
                  fill="#7c7c7c"
                />
              </svg>
            </b-input-group-append>
            <b-form-input
              class="inputSearch"
              :placeholder="$t('placeholder.search')"
              id="inputSearch"
              v-on:keyup.enter="searchTitle()"
            ></b-form-input>
            <b-input-group-append
              class="rigth-app"
              style="cursor: pointer"
              v-on:click="showCollapse = !showCollapse"
            >
              <svg
                width="30px"
                height="30"
                viewBox="0 0 40 40"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <path
                    d="M30.6011726,9 L9.39882738,9 C9.08108106,9 8.87887885,9.34451031 9.08108106,9.63160224 L16.8514228,20.4549679 C17.1980552,20.9143149 17.4002574,21.517208 17.4002574,22.120101 L17.4002574,31.5654254 C17.4291434,31.8812265 17.6891177,32.0821909 17.9490919,31.9673541 L22.3686544,30.3022209 C22.5130845,30.2735117 22.5997426,30.1012566 22.5997426,29.9577106 L22.5997426,22.120101 C22.5997426,21.517208 22.8019448,20.9430241 23.1485772,20.4549679 L30.9189189,9.63160224 C31.1211211,9.34451031 30.9189189,9 30.6011726,9 Z"
                    id="Path"
                    fill="#353639"
                  ></path>
                </g>
              </svg>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="card-serch" v-show="showCollapse">
          <b-row>
            <b-col md="6">
              <b-form-group :label="$t('biblioSegment.author')" label-for="input-sm">
                <v-select
                  :placeholder="$t('biblioSegment.selectAuthor')"
                  v-model="authorModel"
                  :options="auteursList"
                >
                  <span slot="no-options">{{ $t('biblioSegment.noOption') }}</span>
                  <span slot="no-result">{{ $t('biblioSegment.noResult') }}</span>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group :label="$t('biblioSegment.theme')" label-for="input-sm">
                <v-select
                  :placeholder="$t('biblioSegment.selectOneTheme')"
                  :options="themeList"
                  v-model="themeModel"
                >
                  <span slot="no-options">{{ $t('biblioSegment.noOption') }}</span>
                  <span slot="no-result">{{ $t('biblioSegment.noResult') }}</span>
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <div style="text-align: right;">
            <b-button variant="primary" v-on:click="searchOption()">{{
              $t('button.search')
            }}</b-button>
          </div>
        </div>
      </b-col>

      <b-col cols="1" ms="1" style="padding: 0px;">
        <b-button class="btn-lg-w" variant="primary" v-on:click="addnewsegment()"
          ><svg
            class="svg-m"
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="23"
            viewBox="0 0 30 30"
          >
            <path
              id="Color"
              d="M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z"
              transform="translate(3.75 3.75)"
              fill="#ffffff"
            />
          </svg>
          <span class="text-btn-add">
            {{ $t('button.add') }}
          </span>
        </b-button>
      </b-col>
    </b-row>
    <b-row class="row-theme-segment">
      <b-col
        sm="2"
        style="min-width: 240px;"
        id="card-theme-segment"
        class="card-theme-segment no-padding-LR"
      >
        <b-list-group style="width: 100% ; ">
          <b-list-group-item v-on:click="allSegmentsSearch()" class="list-group-item-s">
            <svg
              width="30px"
              height="30px"
              viewBox="0 0 30 30"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <path
                  d="M12.7385714,16.5 C13.1657143,16.5 13.5,16.8342857 13.5,17.2614286 L13.5,17.2614286 L13.5,25.4885714 C13.5,25.9157143 13.1657143,26.25 12.7385714,26.25 L12.7385714,26.25 L4.51142857,26.25 C4.10285714,26.25 3.75,25.8971429 3.75,25.4885714 L3.75,25.4885714 L3.75,17.2614286 C3.75,16.8342857 4.08428571,16.5 4.51142857,16.5 L4.51142857,16.5 Z M25.4885714,16.5 C25.8971429,16.5 26.25,16.8528571 26.25,17.2614286 L26.25,17.2614286 L26.25,25.4885714 C26.25,25.9157143 25.9157143,26.25 25.4885714,26.25 L25.4885714,26.25 L17.2614286,26.25 C16.8342857,26.25 16.5,25.9157143 16.5,25.4885714 L16.5,25.4885714 L16.5,17.2614286 C16.5,16.8342857 16.8342857,16.5 17.2614286,16.5 L17.2614286,16.5 Z M11.9771429,18.0228571 L5.27285714,18.0228571 L5.27285714,24.7271429 L11.9771429,24.7271429 L11.9771429,18.0228571 Z M24.7271429,18.0228571 L18.0228571,18.0228571 L18.0228571,24.7271429 L24.7271429,24.7271429 L24.7271429,18.0228571 Z M12.7385714,3.75 C13.1657143,3.75 13.5,4.08428571 13.5,4.51142857 L13.5,4.51142857 L13.5,12.7385714 C13.5,13.1657143 13.1657143,13.5 12.7385714,13.5 L12.7385714,13.5 L4.51142857,13.5 C4.10285714,13.5 3.75,13.1471429 3.75,12.7385714 L3.75,12.7385714 L3.75,4.51142857 C3.75,4.08428571 4.08428571,3.75 4.51142857,3.75 L4.51142857,3.75 Z M25.4885714,3.75 C25.9157143,3.75 26.25,4.08428571 26.25,4.51142857 L26.25,4.51142857 L26.25,12.7385714 C26.25,13.1657143 25.9157143,13.5 25.4885714,13.5 L25.4885714,13.5 L17.2614286,13.5 C16.8342857,13.5 16.5,13.1657143 16.5,12.7385714 L16.5,12.7385714 L16.5,4.51142857 C16.5,4.08428571 16.8342857,3.75 17.2614286,3.75 L17.2614286,3.75 Z M11.9771429,5.27285714 L5.27285714,5.27285714 L5.27285714,11.9771429 L11.9771429,11.9771429 L11.9771429,5.27285714 Z M24.7271429,5.27285714 L18.0228571,5.27285714 L18.0228571,11.9771429 L24.7271429,11.9771429 L24.7271429,5.27285714 Z"
                  id="Color"
                  fill="#353639"
                ></path>
              </g>
            </svg>
            {{ $t('biblioSegment.allSegments') }}</b-list-group-item
          >
          <b-list-group-item
            v-for="(theme, index) in getThemesList"
            :key="index"
            v-on:click="
              setTheme(theme);
              oldTheme = theme;
            "
            class="list-group-item-s"
          >
            <svg
              width="30px"
              height="30px"
              viewBox="0 0 30 30"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g id="Icon/30/Folder" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <path
                  d="M23.1432119,3.75 C23.6164029,3.75 24,4.13744589 24,4.61538462 L24.0010217,6.92120039 C25.3074906,7.35836309 26.2485229,8.58384412 26.25,10.0277778 L26.25,22.9722222 C26.2478411,24.7816005 24.7706423,26.2478571 22.9477612,26.25 L7.05223881,26.25 C5.22922997,26.2481626 3.75185109,24.7817273 3.75,22.9722222 L3.75,14.9166667 C3.75174771,13.2082172 5.0688174,11.8055885 6.75024042,11.6527052 L6.75,4.61538462 C6.75,4.13744589 7.13359709,3.75 7.60678808,3.75 L23.1432119,3.75 Z M22.9477612,8.41666667 L17.566791,8.41666667 C16.6703587,8.41666667 15.9436567,9.13798568 15.9436567,10.0277778 C15.9414978,11.8371561 14.464299,13.3034126 12.6414179,13.3055556 L7.05223881,13.3055556 C6.15580647,13.3055556 5.42910448,14.0268746 5.42910448,14.9166667 L5.42910448,22.9722222 C5.42910448,23.8620143 6.15580647,24.5833333 7.05223881,24.5833333 L22.9477612,24.5833333 C23.8441935,24.5833333 24.5708955,23.8620143 24.5708955,22.9722222 L24.5708955,10.0277778 C24.5708955,9.13798568 23.8441935,8.41666667 22.9477612,8.41666667 Z M22.2864238,5.48076923 L8.46357616,5.48076923 L8.463,11.638 L12.6414179,11.6388889 C13.4880485,11.6388889 14.1832837,10.9954901 14.257919,10.1744217 L14.2645522,10.0277778 C14.2664033,8.21827271 15.7437822,6.75183737 17.566791,6.75 L22.286,6.75 L22.2864238,5.48076923 Z"
                  id="Color"
                  fill="#353639"
                ></path>
              </g>
            </svg>
            {{ theme.name }}
          </b-list-group-item>
        </b-list-group>
      </b-col>
      <b-col class="custom-mb-row">
        <b-row class="row-m">
          <b-col class="menu-theme" cols="1" style="padding-left: 5px">
            <svg
              width="40px"
              height="40px"
              viewBox="0 0 40 40"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              v-show="isOpen"
              v-on:click="openMenu()"
              class="pointer"
            >
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <path
                  d="M29.3333333,6 C31.8325613,6 33.8729254,7.96462988 33.9942888,10.4337529 L34,10.6666667 L34,29.3333333 C34,31.8325613 32.0353701,33.8729254 29.5662471,33.9942888 L29.3333333,34 L10.6666667,34 C8.16743871,34 6.12707464,32.0353701 6.00571119,29.5662471 L6,29.3333333 L6,10.6666667 C6,8.16743871 7.96462988,6.12707464 10.4337529,6.00571119 L10.6666667,6 L29.3333333,6 Z M29.3333333,8.33333333 L10.6666667,8.33333333 C9.43657791,8.33333333 8.42880736,9.28519076 8.33973336,10.4925273 L8.33333333,10.6666667 L8.33333333,29.3333333 C8.33333333,30.5634221 9.28519076,31.5711926 10.4925273,31.6602666 L10.6666667,31.6666667 L29.3333333,31.6666667 C30.5634221,31.6666667 31.5711926,30.7148092 31.6602666,29.5074727 L31.6666667,29.3333333 L31.6666667,10.6666667 C31.6666667,9.43657791 30.7148092,8.42880736 29.5074727,8.33973336 L29.3333333,8.33333333 Z M27,24.6666667 C27.6443322,24.6666667 28.1666667,25.1890011 28.1666667,25.8333333 C28.1666667,26.4316418 27.7162864,26.9247584 27.136058,26.992151 L27,27 L13,27 C12.3556678,27 11.8333333,26.4776655 11.8333333,25.8333333 C11.8333333,25.2350249 12.2837136,24.7419083 12.863942,24.6745157 L13,24.6666667 L27,24.6666667 Z M27,18.8333333 C27.6443322,18.8333333 28.1666667,19.3556678 28.1666667,20 C28.1666667,20.5983085 27.7162864,21.091425 27.136058,21.1588176 L27,21.1666667 L13,21.1666667 C12.3556678,21.1666667 11.8333333,20.6443322 11.8333333,20 C11.8333333,19.4016915 12.2837136,18.908575 12.863942,18.8411824 L13,18.8333333 L27,18.8333333 Z M27,13 C27.6443322,13 28.1666667,13.5223345 28.1666667,14.1666667 C28.1666667,14.7649751 27.7162864,15.2580917 27.136058,15.3254843 L27,15.3333333 L13,15.3333333 C12.3556678,15.3333333 11.8333333,14.8109989 11.8333333,14.1666667 C11.8333333,13.5683582 12.2837136,13.0752416 12.863942,13.007849 L13,13 L27,13 Z"
                  id="Shape"
                  fill="#7c7c7c"
                ></path>
              </g>
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              v-show="!isOpen"
              v-on:click="openMenu()"
              class="pointer"
            >
              <path
                id="Path"
                d="M.42,2.49A1.486,1.486,0,0,1,.42.42a1.486,1.486,0,0,1,2.07,0L14.911,12.862,27.353.42A1.456,1.456,0,1,1,29.4,2.49L16.981,14.912,29.4,27.354a1.456,1.456,0,1,1-2.049,2.07L14.911,16.982,2.49,29.424a1.486,1.486,0,0,1-2.07,0,1.486,1.486,0,0,1,0-2.07L12.841,14.912Z"
                transform="translate(5.003 5)"
                fill="#7c7c7c"
              />
            </svg>
          </b-col>
          <b-col class=" padding-l-c padding-l" style="padding-right: 0px!important;">
            <b-breadcrumb>
              {{ $t('biblioSegment.allSegments') }}
              <span>{{ currentTheme }}</span>
            </b-breadcrumb>
          </b-col>
        </b-row>

        <not-found v-show="showNotFoundCard && DefaultSegments.length == 0"></not-found>

        <div class="default-modules">
          <div class="row" style="margin-right: 0px!important">
            <div
              class="one-disposition col-xl-3 col-lg-4 col-md-6 col-sm-6 "
              v-for="(item, index) in DefaultSegments"
              :key="item.id"
            >
              <card-segment
                :index="index"
                :key="item.uid"
                :have-screen="item.screens.length > 1"
                :Shot="item.screens[0] ? item.screens[0].screenShot : null"
                :isHover="true"
                :id="item.id"
                :item="item"
                :ModalSegment="true"
                :title="item.title"
                :itemsegment="item"
                :isSelected="selecteIdSegment.includes(item.id)"
                @selected="addSegment(item)"
              ></card-segment>
            </div>
          </div>
          <infinite-loading
            @infinite="loadMoreSegments"
            spinner="bubbles"
            :distance="10"
            :direction="'bottom'"
          >
            <div slot="no-more" v-if="isEndReached('DefaultSegment')"></div>
            <div slot="no-results" v-show="DefaultSegments.length === 0">
              {{ '' }}
            </div>
          </infinite-loading>
        </div>
      </b-col>
    </b-row>
    <screen-in-segment v-if="Object.assign({}, currentSegment) !== {}"></screen-in-segment>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import en from '../../i18n/en_US';
import fr from '../../i18n/fr_FR';
import mixin from '../../mixins/Mixin.js';
import { Carousel, Slide } from 'vue-carousel';
import mixinGrapesHelpers from '../../mixins/GrapesMixinHelpers';
import SegmentList from '../Modal/SegmentList.vue';
import { vueTopprogress } from 'vue-top-progress';
import HasPermission from '../../core/directives/HasPermission.js';
import * as durationHelper from '../../helpers/duration-handler';
import Card from './Card.vue';
import NotFoundCard from './NotFoundCard';
import InfiniteLoading from 'vue-infinite-loading';
import screenInSegment from './screenInSegment';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  name: 'ListSegment',
  mixins: [mixin, mixinGrapesHelpers],
  directives: {
    HasPermission,
  },
  data() {
    return {
      colorBtn: 'rgb(3,155,229)',
      isOpen: false,
      authorModel: '',
      themeModel: '',
      clicksOut: true,
      showCollapse: false,
      navparam: true,
      selectedTab: '',
      infiniteState: null,
      selectedIds: [],
      selecteIdSegment: [],
      showNotFoundCard: false,
      titleTemplate: this.$t('template.new_template'),
      total: 0,
      hideCancelButton: true,
      disabledConfirmButton: true,
      duration: 59,
      currentTheme: '',
      oldTheme: '',

      screenShot:
        'data:image/png;base64,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',
      currentShot:
        'data:image/png;base64,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',
      showScreen: false,
    };
  },
  components: {
    vueTopprogress,
    Carousel,
    Slide,
    SegmentList,
    'card-segment': Card,
    'not-found': NotFoundCard,
    InfiniteLoading,
    screenInSegment,
    'v-select': vSelect,
  },
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  watch: {
    isLoading(isLoading) {
      if (this.infiniteState) {
        if (this.isEndReached('DefaultSegment')) {
          this.infiniteState.complete();
        } else if (!isLoading) {
          this.infiniteState.loaded();
        }
      }
    },
    DefaultSegments(segments) {
      if (segments.length === 0 && this.infiniteState) {
        if (!this.isLoading) {
          this.loadMoreSegments();
        }
        this.infiniteState.reset();
      }
    },
  },
  computed: {
    ...mapGetters({
      //recentsSegment:'segments/getAllSegments',
      screens: 'slides/getAllScreens',
      currentSlide: 'slides/getCurrent',
      dispositions: 'slides/getAllDispositions',
      all: 'segments/getSegments',
      segments: 'segments/getAllSegments',
      DefaultSegments: 'segments/getAllDefaultSegments',
      isLoading: 'segments/getLoading',
      isEndReached: 'segments/getEndReached',
      selected: 'slides/getSelected',
      selectedSegments: 'segments/getSelectedSegments',
      currentSegment: 'segments/getCurrent',
      isSelected: 'slides/isSelected',
      firstSelectedSegment: 'segments/getLastSegmentById',
      showIconSave: 'common/getShowIconSave',
      paramsClient: 'getParamsClients',
      hasPermission: 'hasPermission',
      totalDurationSegments: 'segments/getAllSegmentsDuration',
      getThemesList: 'segments/getThemesList',
      getAuteursList: 'segments/getAuteursList',
    }),
    getColorBtn() {
      if (this.$route.query.color) {
        this.colorBtn = this.$route.query.color;
      }

      return { '--primary-color': this.colorBtn };
    },
    themeList() {
      let list = [];
      this.getThemesList.forEach(t => {
        let o = {};
        o.label = t.name ? t.name : t.title;
        o.code = t.id;
        list.push(o);
      });
      return list;
    },
    auteursList() {
      let list = [];
      this.getAuteursList.forEach(t => {
        let o = {};
        o.label = t.name;
        o.code = t.id;
        list.push(o);
      });
      return list;
    },
  },
  methods: {
    ...mapActions('slides', [
      'paginate',
      'selectSlide',
      'setCurrentSlide',
      'removeLastSlideById',
      'updateSlide',
      'fetch',
      'setTemplate',
    ]),

    ...mapActions('segments', [
      'setThemeid',
      'setAuthorid',
      'setThemes',
      'setfromRouteAdd',
      'getSegments',
      'paginatesegment',
      'selectSegment',
      'setCurrentSegment',
      'removeLastSegmentById',
      'updateSegment',
      'setTitle',
      'resetPage',
      'setSegments',
      'setEndReached',
      'setNbrCall',
      'updateSlideInsideSegment',
      'getAuteurs',
    ]),
    ...mapActions('common', ['setShowIconSave']),
    ...mapActions(['setRoute']),
    loadMoreSegments($state) {
      if (!this.infiniteState) {
        this.infiniteState = $state;
      }
      if (this.isEndReached('DefaultSegment')) {
        this.infiniteState.complete();
        return;
      }

      this.paginatesegment('DefaultSegment');
    },
    openMenu() {
      if (!this.isOpen) {
        document.querySelector('.card-theme-segment').style.display = 'none';
      } else document.querySelector('.card-theme-segment').style.display = 'block';

      this.isOpen = !this.isOpen;
    },
    onResize() {
      if (window.innerWidth > 1000) {
        document.querySelector('.card-theme-segment').style.display = 'block';
        this.isOpen = true;
      } else {
        document.querySelector('.card-theme-segment').style.display = 'none';
        this.isOpen = true;
      }
    },
    searchOption() {
      this.showCollapse = !this.showCollapse;
      if (this.themeModel) {
        this.currentTheme = ' > ' + this.themeModel.label;
      }
      this.setSegments([]);
      this.setEndReached({ type: 'DefaultSegment', endReached: false });
      var title = document.getElementById('inputSearch').value;
      this.setTitle(title);
      this.setThemeid(this.themeModel.code);
      this.setAuthorid(this.authorModel.code);
      this.resetPage('DefaultSegment');
      this.paginatesegment('DefaultSegment');
      this.themeModel = '';
      this.authorModel = '';
    },

    allSegmentsSearch() {
      this.currentTheme = '';
      this.setSegments([]);
      this.setEndReached({ type: 'DefaultSegment', endReached: false });
      this.setAuthorid(null);
      this.setThemeid(null);
      this.setTitle(null);
      this.resetPage('DefaultSegment');
      this.paginatesegment('DefaultSegment');
    },
    setTheme(theme) {
      if (theme === this.oldTheme) {
        return;
      }
      this.currentTheme = ' > ' + theme.name;
      this.setAuthorid(null);
      this.setTitle(null);
      this.setSegments([]);
      this.setEndReached({ type: 'DefaultSegment', endReached: false });
      this.setThemeid(theme.id);
      this.resetPage('DefaultSegment');
      this.paginatesegment('DefaultSegment');
    },
    loadMore() {
      this.isShown = true;
    },
    showTab(tab) {
      this.selectedTab = tab;
    },
    select(item) {
      let selected = JSON.parse(JSON.stringify(item));
      if (this.selectedIds.includes(selected.id)) {
        this.selectedIds = this.selectedIds.filter(i => i !== selected.id);
        this.removeLastSlideById(selected.id);
      } else {
        this.selectedIds.push(selected.id);
        this.selectSlide(selected);
      }
    },

    searchTitle() {
      // this.$refs.topProgress.start();
      var title = document.getElementById('inputSearch').value;
      this.setSegments([]);
      this.setTitle(title);
      this.resetPage('DefaultSegment');
      this.paginatesegment('DefaultSegment');
    },

    addnewsegment() {
      this.setCurrentSegment(null);
      this.setfromRouteAdd(true);

      // Keep the host page's own state in sync.
      let obj = { AddSegment: true };
      parent.postMessage(obj, '*');

      // This component is shared by both entry points. The main app (index.html)
      // owns the editor, so a normal push completes the flow there and keeps the
      // store mutations above intact. The segment app (index_segment.html) has no
      // 'segment' route and so nothing to hand "Suivant" over to, leaving the user
      // stuck; per _redirects, /display/add-segment/* is served by the main app, so
      // hand over with a real navigation instead of dead-ending.
      const canOpenEditor = this.$router.options.routes.some(r => r.name === 'segment');
      if (canOpenEditor) {
        this.$router.push({ name: 'AddSegment' });
      } else {
        window.location.href =
          '/display/add-segment/' + this.$route.params.cryptext + window.location.search;
      }
    },
    //--------
    showThis(item) {
      this.currentShot = item.screenShot ? item.screenShot : this.screenShot;
    },
    getScreens() {
      if (this.currentSegment && this.currentSegment.screens !== undefined) {
        this.exist = true;
        let screens = this.currentSegment.screens;
        return screens && screens.filter(s => !s.type.toLowerCase().includes('generic'));
      }
    },
    closeScreens() {
      document.querySelector('#list-screens').style.display = 'none';
      this.showScreen = false;
    },
  },
  async mounted() {
    this.setThemes();
    this.getAuteurs();
    const urlParams = new URLSearchParams(window.location.color);
    const color = urlParams.get('color') ? urlParams.get('color') : 'rgb(3,155,229)';
    this.colorBtn = color;
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  created() {
    window.addEventListener('resize', this.onResize);

    let self = this;
    eventHub.$on('notFound', val => {
      this.showNotFoundCard = val;
    });
    eventHub.$on('showScreen', val => {
      this.showScreen = val;
    });
  },
};
</script>

<style lang="scss">
#slide-list-segment {
  @import '~bootstrap/scss/bootstrap.scss';
  @import '~bootstrap-vue/src/index.scss';

  .btn-primary {
    background-color: var(--primary-color) !important;
    border-color: var(--primary-color) !important;
  }

  .row-theme-segment {
    height: calc(100% - 80px);
  }

  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // margin: 50px;
  padding: 0;
  height: 100%;
  overflow: hidden;
  .default-modules {
    /* position: absolute; */
    height: calc(100% - 58px);
    width: 100%;
    overflow: auto;
    overflow-x: hidden;
  }
  .segments-cards {
    width: 100%;
    height: 100%;
    overflow: auto;
    overflow-x: hidden;
  }
  .card-group {
    display: flex;
    justify-content: space-between;
    //overflow: auto;
    height: 45em;
  }
  .list-group-item {
    margin-bottom: 0em;
    border-right: 0;
    border-top: 0;
    border-left: 0;
    text-align: left;
    &:hover {
      color: #00aced;
    }
  }
  .allSegment {
    text-align: left;
  }
  .list-group-item:first-child {
    border-bottom: 0;
  }
  .btn-lgS {
    width: 8em;
  }
  .list-group-item:hover {
    cursor: pointer;
  }
}
.rigth-app {
  /* margin-left: 14px; */
  position: absolute;
  z-index: 9;
  right: 0%;
  margin: 0.4em;
}
.left-app {
  margin-left: 0.5em !important;
  position: absolute;
  z-index: 9;
  left: 0%;
  margin: 0.4em;
}
//----------------
.showScreen {
  width: 40em;
}
.img-in {
  //width: 50em;
  margin-bottom: 10em;
  margin-top: 5em;
  display: inline-block;
}
.right-icon-svg {
  margin: 1em;
  right: 1%;
  position: absolute;
  :hover {
    cursor: pointer;
  }
}
.left-icon-svg {
  margin: 1em;
  position: absolute;
}
#list-screens {
  display: none;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  height: 58em;
}
.list-screens {
  max-width: 100% !important;
}
#modal-slides .modal-dialog {
  width: auto !important;
  margin: 0.75rem !important;
}
.screen {
  max-width: 250px;
}
#list-screens .VueCarousel-navigation-button:focus {
  outline: none !important;
}
#list-screens .VueCarousel-slide {
  visibility: visible;
  flex-basis: 100%;
  width: 100%;
}
//0 left 1 center
#list-screens .VueCarousel-slide {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 16.5%;
  flex: 0 0 16.5%;
}

#list-screens .slide {
  margin: 5px !important;
  max-width: 223px;
}
.VueCarousel-navigation .VueCarousel-navigation-button :focus {
  outline: none !important;
}

#slide-list-segment .screen:hover {
  border: 2px solid #007bff8c !important;
  border-radius: 4px;
  padding: 2px;
  cursor: pointer;
}
.screenSelected {
  border: solid;
  border-color: #007bff8c;
}
.drop-search .dropdown-menu {
  position: fixed;
  will-change: transform;
  width: 84%;

  transform: translate3d(3em, 48px, 6em);
}

.card-serch {
  position: absolute;
  width: 100%;
  z-index: 3;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.25rem;
  padding: 3em;
}
.menu-theme {
  display: none;
}

.pointer {
  cursor: pointer;
}
.card-theme-segment {
  max-width: 30%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  overflow: auto;
  height: 100%;
}
.custom-mb-row {
  height: 100%;
}

@media screen and (max-width: 1460px) {
  .text-btn-add {
    display: none;
  }
}
.btn-lg-w {
  width: 100%;
}

.col-11-search {
  padding-left: -2px;
}
@media screen and (max-width: 1000px) {
  .list-group-item-s {
    margin-left: 0px !important;
  }
  .card-theme-segment {
    max-width: 30%;
    position: absolute !important;
    z-index: 9;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.2);
    top: 8em;
    left: 1em;
    max-height: 40%;
    overflow-y: auto;
  }
  .btn-lg-w {
    //width: 3em!important;
  }
  .menu-theme {
    display: block;
  }
  .no-padding-LR {
    padding-left: 30px !important;
  }
  .custom-mb-row {
    margin-left: 30px !important;
  }
  .padding-l-c {
    padding-left: 15px !important;
    margin-left: 0px !important;
  }
}
.col-11-search {
  padding: 0px !important;
  padding-right: 10px !important;
}
.padding-l {
  margin-left: -15px;
}
.search-col {
  padding: 0 !important;
  .search-group {
    display: flex;
    align-items: center;
  }
  .inputSearch {
    border-color: #7c7c7c;
    padding: 1.2rem 3rem !important;
    border-radius: 0.4rem;
    border-top-left-radius: 0.4rem !important;
    border-bottom-left-radius: 0.4rem !important;
    border-top-right-radius: 0.4rem !important;
    border-bottom-right-radius: 0.4rem !important;
    color: #797a8e;
    font-size: 0.9em;
  }
  .search-icon {
    cursor: pointer;
    position: absolute;
    z-index: 7;
    display: flex;
    justify-content: center;
    padding: 0.5em 0.5em;
    svg {
      width: 25px;
      height: 100%;
      display: flex;
      justify-content: center;
      path {
        fill: #797a8e;
      }
    }
  }
  .search-button {
    border-right: none !important;
    background-color: #ffffff;
    color: #7c7c7c;
    border-color: #7c7c7c;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}
.no-padding-LR {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
#slide-list-segment .breadcrumb {
  background-color: #dfdfdf !important;
  border-radius: 0px !important;
}
.menu-theme.col-1 {
  max-width: 45px !important;
}
.row-m {
  margin-right: -30px !important;
}
.card-nav {
  margin: 20px !important;
}
.list-group-item-s {
  margin-left: 20px;
}
@media screen and (max-width: 500px) {
  .svg-m {
    margin-left: -5px !important;
  }
}

#slide-list-segment .dropdown-item:active {
  background-color: var(--primary-color) !important;
}
</style>



// WEBPACK FOOTER //
// ListSegment.vue?4b7f10c2